export const version = '2.14.12';
//# sourceMappingURL=version.js.map